module.exports = fox._r("fonts/promo-social-icon-set.svg?6587jk", __webpack_public_path__ + "fonts/promo-social-icon-set.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/promo-social-icon-set.svg?6587jk
// module id = 567
// module chunks = 2